<template>
  <div class="vh-100 d-flex justify-content-center">
    <div class="form-access my-auto">
      <form>
        <span><img src="/img/logo.jpg" alt="" /></span>
        <span>Sign In</span>
        <div class="form-group">
          <input
            type="email"
            class="form-control"
            placeholder="Email Address"
            required
            v-model="form.email"
          />
        </div>
        <div class="form-group">
          <input
            type="password"
            class="form-control"
            placeholder="Password"
            required
            v-model="form.pwd"
          />
        </div>
        <!-- <div class="text-end">
          <router-link to="/reset">Forgot Password?</router-link>
        </div>
        <div class="custom-control form-check">
          <input type="checkbox" class="form-check-input" id="form-checkbox" />
          <label class="form-check-label" htmlFor="form-checkbox">
            Remember me
          </label>
        </div> -->
        <button type="button" class="btn btn-primary" @click="login">
          Sign In
        </button>
      </form>
      <h2 style="font-size: 30px;">
        Don't have an account?
        <router-link to="/sign-up">Sign up here</router-link><br />
        <router-link to="/">Exchange</router-link>
      </h2>
    </div>
  </div>
</template>

<script>
import { login } from "@/apis/user";
import { setToken } from "@/utils/auth";

export default {
  data() {
    return {
      form: {
        email: "",
        pwd: "",
      },
    };
  },
  methods: {
    login() {
      login(this.form).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.$store.dispatch("getUserInfo");
          setToken(res.data.token);
          this.$store.commit("setIsLogin", true);
          this.$router.push("/");
        }
      });
    },
  },
};
</script>
